<div class="message-wrapper">
    <span class="accuris-logo"></span>
    <markdown class="body-md-16-regular message-text" [data]="message"></markdown>
</div>
